import { LOADERS } from '../config/constants'
import { familyLoader } from './family'
import { aggLoader } from './agg'
import { cliLoader } from './cli'
import { perLoader } from './per'
import { paymentLoader } from './payment'
import { paymentProcessingLoader } from './paymentProcessing'
import { resLoader } from './res'
import { fileLoader } from './file'
import { formLoader } from './form'
import { importerLoader } from './importer'
import { learnLoader } from './learn'
import { attendanceLoader } from './attendance'
import { publicLoader } from './public'
import { eventLoader } from './event'
import { managementLoader } from './management'
import { reportLoader } from './report'
import { uploadLoader } from './upload'
import { notificationLoader } from './notification'
import { signalRLoader } from './signalR'

export const getLoader = (loader: string) => {
  switch (loader) {
    case LOADERS.attendance:
      return attendanceLoader
    case LOADERS.agg:
      return aggLoader
    case LOADERS.cli:
      return cliLoader
    case LOADERS.per:
      return perLoader
    case LOADERS.res:
      return resLoader
    case LOADERS.family:
      return familyLoader
    case LOADERS.payment:
      return paymentLoader
    case LOADERS.payProcessing:
      return paymentProcessingLoader
    case LOADERS.file:
      return fileLoader
    case LOADERS.form:
      return formLoader
    case LOADERS.importer:
      return importerLoader
    case LOADERS.learn:
      return learnLoader
    case LOADERS.public:
      return publicLoader
    case LOADERS.event:
      return eventLoader
    case LOADERS.mgmt:
      return managementLoader
    case LOADERS.report:
      return reportLoader
    case LOADERS.upload:
      return uploadLoader
    case LOADERS.notification:
      return notificationLoader
    case LOADERS.signalR:
      return signalRLoader
    default:
      return null
  }
}
